import React from 'react';
import { node, bool, string, oneOf, func } from 'prop-types';
import classnames from 'classnames';

export const LABEL_BEFORE = Symbol('before');
export const LABEL_AFTER = Symbol('after');

export const SwitchLabel = ({ id, htmlFor, children }) => (
  // eslint-disable-next-line jsx-a11y/label-has-for
  <label
    id={id}
    htmlFor={htmlFor}
    className="mdc-switch-label mdc-form-field-label"
  >
    {children}
  </label>
);

SwitchLabel.propTypes = {
  id: string,
  htmlFor: string.isRequired,
  children: node.isRequired,
};

SwitchLabel.defaultProps = {
  id: undefined,
};

export const Switch = ({
  id, labelId, disabled, className, inputRef, ...props
}) => (
  <div
    className={classnames(
      'mdc-switch',
      { 'mdc-switch--disabled': disabled },
      className,
    )}
  >
    <input
      id={id}
      type="checkbox"
      className="mdc-switch__native-control"
      disabled={disabled}
      aria-labelledby={labelId}
      ref={inputRef}
      {...props}
    />
    <div className="mdc-switch__background">
      <div className="mdc-switch__knob" />
    </div>
  </div>
);

Switch.propTypes = {
  id: string.isRequired,
  labelId: string,
  disabled: bool,
  inputRef: func,
};

Switch.defaultProps = {
  labelId: undefined,
  disabled: false,
  inputRef: () => null,
};

const SwitchField = ({
  id, className, label, labelPosition, labelId, ...props
}) => {
  const switchLabel = label ? (
    <SwitchLabel
      id={labelId}
      htmlFor={id}
    >{label}
    </SwitchLabel>
  ) : '';

  return (
    <div className={classnames(
      'mdc-form-field',
      className,
    )}
    >
      {label && labelPosition === LABEL_BEFORE && switchLabel}
      <Switch id={id} labelId={labelId} {...props} />
      {label && labelPosition === LABEL_AFTER && switchLabel}
    </div>
  );
};

SwitchField.LABEL_BEFORE = LABEL_BEFORE;
SwitchField.LABEL_AFTER = LABEL_AFTER;

SwitchField.propTypes = {
  id: string.isRequired,
  labelId: string,
  label: node,
  labelPosition: oneOf([LABEL_BEFORE, LABEL_AFTER]),
};

SwitchField.defaultProps = {
  labelId: undefined,
  label: undefined,
  labelPosition: LABEL_AFTER,
};

export default SwitchField;
